import React from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import 'ckeditor5-custom-build/build/translations/vi'
import CustomUploadAdapterPlugin from './FileUpload'

const getLinkConfig = (link) => ({
  ...link,
  decorators: {
    openInNewTab: {
      mode: 'manual',
      label: 'Mở liên kết trong tab mới',
      attributes: {
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    },
    ...(link?.decorators || {}),
  },
})

const TextEditor = ({ config = {}, ...props }) => {
  const extraPlugins = config.extraPlugins || []

  return (
    <CKEditor
      editor={Editor}
      config={{
        ...config,
        link: getLinkConfig(config.link),
        extraPlugins: [CustomUploadAdapterPlugin, ...extraPlugins],
      }}
      {...props}
    />
  )
}

export default TextEditor
